<template>
  <div class="flex flex-col gap-[24px] px-[20px] pt-[16px] mx-auto">
    <template v-for="itemIdx in 4" :key="itemIdx">
      <div class="content-stretch flex gap-[16px] items-start relative shrink-0 w-full">
        <div
          class="basis-0 content-stretch flex flex-col gap-[8px] grow items-start min-h-px min-w-px relative shrink-0"
        >
          <!-- Tags -->
          <div class="content-stretch flex flex-wrap gap-[4px] items-start relative">
            <SkeletonBase width="40px" height="24px" borderRadius="16px" />
            <SkeletonBase width="60px" height="24px" borderRadius="16px" />
          </div>
          <!-- Title -->
          <div class="flex flex-col gap-2">
            <SkeletonBase width="90%" height="22px" />
            <SkeletonBase width="60%" height="22px" />
          </div>
          <!-- Date -->
          <SkeletonBase width="80px" height="16px" />
        </div>
        <!-- thumbnail -->
        <div class="rounded-[8px] shrink-0 overflow-hidden aspect-[16/9] w-[104px]">
          <SkeletonBase width="100%" height="100%" borderRadius="0" />
        </div>
      </div>
      <hr v-if="itemIdx !== 4" class="border-[#C0C0C0] border-[0.5px]" />
    </template>
  </div>
</template>

<script>
import SkeletonBase from '@/components/common/SkeletonBase.vue';

export default {
  name: 'SkeletonChurchUpdates',
  components: { SkeletonBase },
};
</script>

<style scoped>
* {
  font-family: 'Inter';
}
</style>
